import React from "react";
import { APPLICATION } from "../../data";
import { MessageCircle } from "lucide-react";
import SectionHead from "./SectionHead";

const WA_LINK = "https://wa.me/393514197003";

export default function Application() {
  return (
    <section id="candidatura" className="sec">
      <div className="mx-auto max-w-[720px] px-4 text-center lg:max-w-[1000px] lg:px-12">
        <SectionHead index={APPLICATION.index} title={APPLICATION.title} />
        <p className="mt-6 mx-auto max-w-[60ch]" style={{ fontSize: "1.06rem" }}>{APPLICATION.body}</p>

        <div className="mt-10 flex justify-center">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="application-whatsapp-btn"
            className="btn btn-blue"
          >
            <MessageCircle size={20} /> {APPLICATION.submit}
          </a>
        </div>
      </div>
    </section>
  );
}
